import { Link } from 'react-router-dom';
import { Music, Mail, Phone, MapPin, Instagram, Youtube, Facebook } from 'lucide-react';

const LOGO_URL = "/NSM LOGO White.png";

export const Footer = () => {
  return (
    <footer className="bg-[#0a0a0a] border-t border-[#2A2A2A]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="md:col-span-2">
            <img
              src={LOGO_URL}
              alt="Nathaniel School of Music"
              className="h-12 w-auto mb-6"
            />
            <p className="text-[#A1A1AA] text-sm leading-relaxed max-w-md">
              Transform your musical journey with world-class piano education.
              From beginners to professionals, we craft personalized learning experiences
              that inspire and elevate your artistry.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading text-[#F5F5DC] text-lg mb-4">Quick Links</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/apply" className="text-[#A1A1AA] hover:text-[#D4AF37] text-sm transition-colors">
                  New Student Application
                </Link>
              </li>
              <li>
                <Link to="/repackage" className="text-[#A1A1AA] hover:text-[#D4AF37] text-sm transition-colors">
                  Current Student Repackaging
                </Link>
              </li>
              <li>
                <Link to="/returning" className="text-[#A1A1AA] hover:text-[#D4AF37] text-sm transition-colors">
                  Returning Student
                </Link>
              </li>
              <li>
                <Link to="/admin" className="text-[#A1A1AA] hover:text-[#D4AF37] text-sm transition-colors">
                  Admin Portal
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-heading text-[#F5F5DC] text-lg mb-4">Connect</h4>
            <ul className="space-y-3">
              <li className="flex items-center space-x-2 text-[#A1A1AA] text-sm">
                <Mail size={16} className="text-[#D4AF37]" />
                <span>music@nathanielschool.com</span>
              </li>
              <li className="flex items-center space-x-2 text-[#A1A1AA] text-sm">
                <Phone size={16} className="text-[#D4AF37]" />
                <span>+91 7760456847</span>
              </li>
              <li className="flex items-center space-x-2 text-[#A1A1AA] text-sm">
                <MapPin size={16} className="text-[#D4AF37]" />
                <span>Bangalore, India</span>
              </li>
            </ul>
            
            {/* Social Links */}
            <div className="flex space-x-4 mt-6">
              <a href="#" className="text-[#A1A1AA] hover:text-[#D4AF37] transition-colors">
                <Instagram size={20} />
              </a>
              <a href="#" className="text-[#A1A1AA] hover:text-[#D4AF37] transition-colors">
                <Youtube size={20} />
              </a>
              <a href="#" className="text-[#A1A1AA] hover:text-[#D4AF37] transition-colors">
                <Facebook size={20} />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-[#2A2A2A]">
          <p className="text-[#A1A1AA] text-xs text-center">
            © {new Date().getFullYear()} Nathaniel School of Music. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
